// extracted by mini-css-extract-plugin
export default {"rich-text-editor":"_142IODkNuVEPo7g2SL3Zad"};